module.exports = __webpack_public_path__ + "static/mix-foundation-49b9cfa2b864354e68d58407972e16aa.png";